'use strict';

/**
 * MarkerClusterRenderer
 *
 * Reponsible for getting a set of markers rendered to the map as a markercluster
 * group. Makes use of arbitrary transforms to translate the raw collection into
 * a set of Leafet markers to be added.
 *
 * @uses Leaflet MarkerClusterGroup
 *
 * TODO merge with GeoJson Renderer
 */

var _ = require('lodash');
var Renderer = require('./Renderer');

var MarkerClusterRenderer = Renderer.extend({

  /**
   * @param {Object} clusterOptions see https://github.com/Leaflet/Leaflet.markercluster#all-options
   */
  constructor: function (options, clusterOptions) {

    Renderer.call(this, options);

    // create a new cluster
    clusterOptions = clusterOptions || {};
    this._cluster = L.markerClusterGroup();

    // add cluster to the map
    this.map.addLayer(this._cluster);
  },

  reset: function () {
    // reset the cluster
    this._cluster.clearLayers();
  },

  render: function (dataset) {

    // reset before rendering
    // ... may need to change in the future
    this.reset();

    if (this.transformer) {
      var layers = this.transformer.parse(dataset);
      this._addLayers(layers);
    } else {
      throw new Error('Renderer needs a transformer');
    }

    // return layer for consistency with current GeoJson implementation
    // ... TODO should be refactored out once GeoJsonRenderer actually renders
    return layers;
  },

  _addLayers: function (layers) {

    var leafletLayers = _.map(layers, function (layer) {

      var coords = layer.data.geometry.coordinates.slice(); // coords is [lng, lat]
      var latlng = coords.reverse(); // reverse to [lat, lng]

      // create the leaflet layer
      var leafletLayer = layer.pointToLayer(
        layer.data,
        latlng
      );

      // The marker layer is added and removed multiple times throughout the
      // lifecyle of the app (whenever the user zooms in or out). So we need
      // to ensure that our wrapper is set up whenever that happens.
      leafletLayer.on('add', function () {
        if (layer.onEachFeature) {
          layer.onEachFeature(
            layer.data,
            leafletLayer
          );
        }
      });

      return leafletLayer;
    }.bind(this));


    // add in bulk...
    // https://github.com/Leaflet/Leaflet.markercluster#bulk-adding-and-removing-markers
    this._cluster.addLayers(leafletLayers);
  }
});

module.exports = MarkerClusterRenderer;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/render/MarkerClusterRenderer.js